import React, { ReactNode } from "react"

interface BackgroundWrapperProps {
  bgImage?: string
  className?: string
  children: ReactNode
  showImage?: boolean
}

const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({
  bgImage,
  className,
  children,
  showImage = true,
}) => {
  const defaultBg = "/assets/alpha-event-bg.svg"

  return (
    <div
      className={`flex flex-col bg-black !bg-cover !bg-no-repeat  ${className || ""}`.trim()}
      style={{
        background: showImage ? `url(${bgImage || defaultBg})` : "none",
        backgroundPosition: "center",
      }}
    >
      {children}
    </div>
  )
}

export default BackgroundWrapper
